export const LEAD_GENERATION_STATS_REPORTS_REFRESH_SECONDS = 15;
